import React from "react";
import useScreenOrientation from '../helpers/useScreenOrientation';

export default function CarouselCard({ scenario, setScenario}: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`scenario-carousel-item ${scenario.interactable === true ? '' : 'disabled'}`} onClick={() => setScenario(scenario)}>
      <div className={`scenario-carousel-item-icon ${isLandscape ? '' : 'portrait'}`} style={{backgroundImage: `url(${scenario.icon})`}} />
      <div className="scenario-carousel-item-text" >{scenario.name}</div>      
    </div>
  );
}
